import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Globe, CaretDown, Check } from "@phosphor-icons/react";
import { SUPPORTED } from "@/i18n";

export default function LanguageSwitcher({ compact = false }) {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function onClick(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  const current = SUPPORTED.find((s) => s.code === i18n.language) || SUPPORTED[0];

  function pick(code) {
    i18n.changeLanguage(code);
    setOpen(false);
  }

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        data-testid="lang-switcher-btn"
        aria-label={t("common.language")}
        className="btn-ghost inline-flex items-center gap-1.5 text-sm"
      >
        <Globe size={16} />
        {!compact && <span className="font-mono text-xs uppercase">{current.code}</span>}
        <CaretDown size={10} />
      </button>
      {open && (
        <div data-testid="lang-switcher-menu" className="absolute right-0 rtl:right-auto rtl:left-0 top-full mt-1 w-44 bg-white border border-zinc-200 shadow-lg z-[80]">
          {SUPPORTED.map((s) => {
            const active = s.code === current.code;
            return (
              <button
                key={s.code}
                onClick={() => pick(s.code)}
                data-testid={`lang-${s.code}`}
                className={(active ? "bg-zinc-950 text-white" : "hover:bg-zinc-50") + " w-full flex items-center gap-2 px-3 py-2 text-sm text-left"}
              >
                <span className="text-base leading-none">{s.flag}</span>
                <span className="flex-1">{s.native}</span>
                <span className="font-mono text-[10px] opacity-60">{s.code.toUpperCase()}</span>
                {active && <Check size={12} />}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
